const team = "https://ik.imagekit.io/sbrqdqxneo/Team/team.jpg?updatedAt=1759422449608"
export {team}